import './Flower.css';

export default function Flower({
flowerClass
})
{

    return (
        <>
            <img src='/Purple_flower.png' className={`flower ${flowerClass}`}/>
        </>
    )
}